export default {
  list: {
    title: 'Palabras',
    subtitle: 'Lista',
    add: 'Nueva palabra',
  },
  create: {
    title: 'Agregar',
    subtitle: 'Palabras',
  },
  importPage: {
    title: 'Importar',
    subtitle: 'Palabras',
  },
  importList: {
    title: 'Importación de Palabras',
    subtitle: 'Historial',
    add: 'Importar palabras',
    cardTitle: 'Historial de Importaciones',
    searchPlaceholder: 'Buscar por archivo...',
  },
  importForm: {
    cardTitle: 'Importar Archivo (.txt)',
    actions: 'Acciones',
  },
  edit: {
    subtitle: 'Banco de Preguntas',
    questionsTitle: 'Preguntas',
    addQuestion: 'Nueva Pregunta',
    levelFilter: 'Filtro por nivel',
  },
  table: {
    title: 'Palabras Activas',
    searchPlaceholder: 'Buscar por algo...',
    exportTxt: 'Exportar en .txt',
    noContent: 'Aún no hay ninguna palabra registrada.',
    columns: {
      name: 'Nombre',
      options: 'Opciones',
    },
  },
  importTable: {
    columns: {
      date: 'Fecha',
      file: 'Archivo',
      user: 'Usuario',
      totalRead: 'Total Leídas',
      inserted: 'Insertadas',
      options: 'Opciones',
    },
    system: 'Sistema',
    hide: 'Ocultar',
    viewWords: 'Ver Palabras',
    newWordsImported: 'palabras nuevas importadas:',
    noContent: 'Ningún historial de importación encontrado.',
  },
  form: {
    word: {
      label: 'Palabra:',
      placeholder: 'Escriba la palabra',
      invalid: 'Este campo es obligatorio',
    },
  },
  question: {
    columns: {
      question: 'Pregunta',
      level: 'Nivel',
      options: 'Opciones',
    },
    empty: 'Ninguna pregunta registrada.',
    addFirst: 'Agregar la primera',
    placeholder: 'Escriba la pregunta aquí...',
  },
  delete: {
    title: 'Confirme la exclusión de la palabra',
    message: '¿Está seguro de que desea eliminar esta palabra?',
    questionTitle: 'Eliminar Pregunta',
    questionMessage:
      '¿Está seguro de que desea eliminar esta pregunta del sistema permanentemente?',
  },
  alert: {
    saved: '¡Palabra guardada con éxito!',
    deleted: 'Palabra eliminada con éxito',
    downloadSuccess: '¡Descarga finalizada con éxito!',
    importSuccess: '¡{inserted} palabras insertadas de {total}!',
    importError: 'Error al importar el archivo.',
    invalidFileFormat: 'El formato del archivo debe ser .txt',
    loadWordError: 'Error al cargar la palabra',
    questionDeleted: '¡Pregunta eliminada!',
    questionDeleteError: 'Error al eliminar.',
    questionUpdated: '¡Pregunta actualizada!',
    questionCreated: '¡Pregunta registrada!',
    questionSaveError: 'Error al guardar la pregunta.',
    saveOrCancelBeforeFilter:
      'Guarde o cancele los cambios antes de filtrar.',
  },
};
